import React from 'react';
import Select from 'react-select';
import { Button as ChakraButton } from '@chakra-ui/react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { IDefaultValue } from '../../../models/DefaultValue';

interface SelectOption {
    value: string;
    label: string;
}

type Props = {
    isOpen: boolean;
    title: string;
    buttonText: string;
    defaultValue?: IDefaultValue;
    formDefaultValue: IDefaultValue;
    companyOptions: SelectOption[];
    toggle: () => void;
    onConfirm?: (defaultValue: IDefaultValue) => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSidChange?: (sid: string) => void;
};

const selectMenuStyle = { menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) };

function ManageDefaultValueModal(props: Props) {
    const {
        isOpen,
        title,
        buttonText,
        defaultValue,
        formDefaultValue,
        companyOptions,
        toggle,
        onConfirm,
        onChange,
        onSidChange,
    } = props;

    const isEditMode = Boolean(defaultValue?.sid);

    return (
        <Modal keyboard backdrop isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{title}</ModalHeader>

            <ModalBody>
                <form>
                    <div>
                        <div className="form-group">
                            <label>บริษัท <span style={{ color: 'red' }}>*</span></label>
                            <Select
                                menuPortalTarget={document.body}
                                styles={selectMenuStyle}
                                placeholder="เลือก บริษัท"
                                options={companyOptions}
                                value={companyOptions.find(c => c.value === formDefaultValue?.sid) ?? null}
                                onChange={opt => onSidChange?.(opt?.value ?? '')}
                                isDisabled={isEditMode || companyOptions.length === 1}
                            />
                        </div>

                        <div className="form-group mt-2">
                            <label>Key <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Key"
                                name="key"
                                value={String(formDefaultValue?.key)}
                                disabled={isEditMode}
                                onChange={onChange}
                            />
                        </div>

                        <div className="form-group mt-2">
                            <label>Value</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Value"
                                name="value"
                                value={String(formDefaultValue?.value)}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </form>
            </ModalBody>

            <ModalFooter>
                <Button color="primary" onClick={() => onConfirm?.(formDefaultValue)}>
                    {buttonText}
                </Button>

                <ChakraButton colorScheme="red" onClick={toggle}>
                    Cancel
                </ChakraButton>
            </ModalFooter>
        </Modal>
    );
}

export default ManageDefaultValueModal;
